import { Control, Controller } from 'react-hook-form';

import MobilePhoneInput from '@/components/inputs/MobilePhoneInput';

export interface FormMobilePhoneInputProps {
  control: Control<any>;
  name: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
}

const FormMobilePhoneInput = ({
  control,
  name,
  placeholder = 'Teléfono',
  required = false,
  disabled = false,
  autoFocus = false,
}: FormMobilePhoneInputProps) => (
  <Controller
    name={name}
    control={control}
    render={({ field, fieldState: { error } }) => (
      <MobilePhoneInput
        ref={field.ref}
        name={name}
        placeholder={placeholder}
        value={field.value}
        onChange={field.onChange}
        onBlur={field.onBlur}
        required={required}
        disabled={disabled}
        autoFocus={autoFocus}
        error={!!error}
        errorInfo={error?.message}
      />
    )}
  />
);

export default FormMobilePhoneInput;
